import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 pb-20" }

import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import AudienceNeue from '@/components/neue/AudienceNeue.vue'
import { useBackLink } from '@/composables/useBackLink'
import { TIER_AUDIENCE_TABS, TIER_OVERVIEW_TAB, tierViewPath } from '@/config/membershipTierView'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'
import { mapType } from '@/store/mappers'
import MoveMembersModal from '@/view/store/membershipTierOverview/MoveMembersModal.vue'
import TierHeader from '@/view/store/membershipTierOverview/TierHeader.vue'
import TierOverviewPanel from '@/view/store/membershipTierOverview/TierOverviewPanel.vue'


export default {
  __name: 'MembershipTierOverview',
  setup(__props) {

const route = useRoute()
const backLink = useBackLink('/store/membership-tiers')
const canReadCustomers = computed(() => privilegeService.canAccessResourceAction('customers', null, 'read'))

const tierId = computed(() => String(route.params.id))
const tiersLoaded = ref(false)
const tierEntities = computed(() => mapType('membership_tier'))
const tier = computed(() => tierEntities.value.find(t => String(t.id) === tierId.value) ?? null)
const tierName = computed(() => tier.value?.attributes.tier_name || (tiersLoaded.value ? '' : 'Membership tier'))
const audienceId = computed(() => {
  const id = tier.value?.relationships?.audience?.data?.id
  return id ? String(id) : null
})
const otherTiers = computed(() =>
  tierEntities.value
    .filter(t => String(t.id) !== tierId.value)
    .map(t => ({ id: String(t.id), name: t.attributes.tier_name || `Tier #${t.id}` }))
)

const header = computed(() => ({
  tierId: tierId.value,
  tierName: tierName.value,
  parent: backLink.value,
  canMove: Boolean(tier.value)
}))

const moveOpen = ref(false)
const version = ref(0)

const fetchTiers = async () => {
  try {
    await api.call('GET', 'membership_tiers?included=none')
  } finally {
    tiersLoaded.value = true
  }
}

watch(tierId, () => (moveOpen.value = false))

fetchTiers()

return (_ctx, _cache) => {
  const _component_EmptyState = _resolveComponent("EmptyState")
  const _component_NeueWell = _resolveComponent("NeueWell")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (audienceId.value && canReadCustomers.value)
      ? (_openBlock(), _createBlock(AudienceNeue, {
          key: 0,
          "audience-id": audienceId.value,
          "base-path": _unref(tierViewPath)(tierId.value),
          "only-tabs": _unref(TIER_AUDIENCE_TABS),
          "lead-tab": _unref(TIER_OVERVIEW_TAB)
        }, {
          top: _withCtx(({ sections }) => [
            _createVNode(TierHeader, _mergeProps(header.value, {
              sections: sections,
              onMove: _cache[0] || (_cache[0] = $event => (moveOpen.value = true))
            }), null, 16, ["sections"])
          ]),
          lead: _withCtx(() => [
            _createVNode(TierOverviewPanel, {
              "tier-id": tierId.value,
              "tier-name": tierName.value,
              version: version.value
            }, null, 8, ["tier-id", "tier-name", "version"])
          ]),
          _: 1
        }, 8, ["audience-id", "base-path", "only-tabs", "lead-tab"]))
      : (_openBlock(), _createBlock(_component_SecondaryNav, { key: 1 }, {
          top: _withCtx(() => [
            _createVNode(TierHeader, _mergeProps(header.value, {
              onMove: _cache[1] || (_cache[1] = $event => (moveOpen.value = true))
            }), null, 16)
          ]),
          main: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (tiersLoaded.value && !tier.value)
                ? (_openBlock(), _createBlock(_component_NeueWell, {
                    key: 0,
                    class: "text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EmptyState, {
                        plural: "membership tier",
                        description: "This membership tier could not be found."
                      })
                    ]),
                    _: 1
                  }))
                : (tier.value)
                  ? (_openBlock(), _createBlock(TierOverviewPanel, {
                      key: 1,
                      "tier-id": tierId.value,
                      "tier-name": tierName.value,
                      version: version.value
                    }, null, 8, ["tier-id", "tier-name", "version"]))
                  : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })),
    _createVNode(MoveMembersModal, {
      open: moveOpen.value,
      "tier-id": tierId.value,
      "tier-name": tierName.value,
      tiers: otherTiers.value,
      onClose: _cache[2] || (_cache[2] = $event => (moveOpen.value = false)),
      onMoved: _cache[3] || (_cache[3] = $event => (version.value++))
    }, null, 8, ["open", "tier-id", "tier-name", "tiers"])
  ], 64))
}
}

}